import React from 'react'
import cn from 'classnames'

import styles from './OrderInformation.module.scss'

const OrderInformation = ({ hidePayment, hideModifiedAt, payment, amount, grandTotal, note, modifiedAt, account, orderNumber, tenderAmount, remainingBalance, className }) => {
  const classNames = cn(styles.orderInformation, className)

  return (
    <div className={classNames}>
      <span className={styles.account}>{account}: {orderNumber && `#${orderNumber}`}</span>
      {!hidePayment && <span>Payment: {payment}</span>}
      {!hideModifiedAt && modifiedAt && <span>Modified: {modifiedAt}</span>}
      {amount && <span>Subtotal: {amount}</span>}
      {grandTotal && <span>Grand Total: {grandTotal}</span>}
      {tenderAmount && <span>Tender Amount: {tenderAmount}</span>}
      {remainingBalance && <span>Balance Due: {remainingBalance}</span>}
      {note && <span>Note: {note}</span>}
    </div>
  )
}

export default OrderInformation
